import React from 'react';
import { useTranslation } from 'react-i18next';

import { BillingSubscription } from '../../Supplements/SplashPage';
import Button from '../../../../components/Button';
import ConfirmModal from '../../../../components/modals/ConfirmModal';
import * as events from '../../../../lib/analytics/events';
import styles from '../../styles/SubscriptionContainer.module.scss';
import { supplementCancellationReason } from '../../../../types/gql-op-types';

type SubscriptionType = 'collar' | 'supplement';

interface ICancelConfirmationModalProps {
  onContinue: () => void;
  pageName: string;
  petId?: string;
  subscription?: BillingSubscription;
  trigger?: React.ReactElement;
  subscriptionType?: SubscriptionType;
  cancellationReason?: supplementCancellationReason;
  cancellationText?: string;
}

export default function CancelConfirmationModal({
  onContinue,
  pageName,
  petId,
  trigger,
  subscription,
  subscriptionType = 'collar',
  cancellationReason,
  cancellationText,
}: ICancelConfirmationModalProps) {
  const { t } = useTranslation();
  const onAccept = () => {
    if (subscriptionType === 'collar') {
      events.inAppCancellation.cancelConfirmationModalContinue({ petId }, pageName);
    }
    if (subscriptionType === 'supplement') {
      events.supplementsManagement.cancelConfirmationModalContinue(
        { subscriptionId: subscription?.id, cancellationReason, cancellationText },
        pageName,
      );
    }
    onContinue();
  };
  const onDecline = () => {
    if (subscriptionType === 'collar') {
      events.inAppCancellation.cancelConfirmationModalGoBack({ petId }, pageName);
    }
    if (subscriptionType === 'supplement') {
      events.supplementsManagement.cancelConfirmationModalGoBack(
        { subscriptionId: subscription?.id, cancellationReason, cancellationText },
        pageName,
      );
    }
  };
  return (
    <ConfirmModal
      trigger={
        trigger ?? (
          <Button className={styles.button} tertiary={true}>
            {t('continue_with_cancellation')}
          </Button>
        )
      }
      body={
        <>
          <div className={styles.header}>
            <h3>{t('are_you_sure')}</h3>
          </div>
          {subscriptionType === 'collar' ? (
            <p>{t('this_will_create_a_customer_support_ticket_to_end_your_subscription_with_fi')}</p>
          ) : (
            <p>
              {t('this_will_stop_shipment_and_subscription_of_your_supplement_name_supplement', {
                supplementName: subscription?.subscriptionOption?.inAppManagementName,
              })}
            </p>
          )}
          {subscriptionType === 'collar' && (
            <p>
              {t('there_will_be_a_20_reactivation_fee_if_you_decide_to_restart_your_subscription_after_you_cancel')}
            </p>
          )}
        </>
      }
      acceptText={t('yes_continue')}
      declineText={t('no_go_back')}
      onAccept={onAccept}
      onDecline={onDecline}
    />
  );
}
